/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiSubEvent} from "./UiSubEvent";
import {UiDummyComponent_ClickedEvent} from "./UiDummyComponentConfig"
import {UiCalendar_EventClickedEvent} from "./UiCalendarConfig"
import {UiCalendar_EventMovedEvent} from "./UiCalendarConfig"
import {UiCalendar_DayClickedEvent} from "./UiCalendarConfig"
import {UiCalendar_ViewChangedEvent} from "./UiCalendarConfig"
import {UiCalendar_DataNeededEvent} from "./UiCalendarConfig"
import {UiContextMenu_ContextMenuSelectionEvent} from "./UiContextMenuConfig"
import {UiGridForm_SubmittedEvent} from "./UiGridFormConfig"
import {UiGridForm_SectionCollapsedStateChangedEvent} from "./UiGridFormConfig"
import {UiImageDisplay_ImagesRequestEvent} from "./UiImageDisplayConfig"
import {UiImageDisplay_ImageDisplayedEvent} from "./UiImageDisplayConfig"
import {UiImageCropper_CropFrameChangedEvent} from "./UiImageCropperConfig"
import {UiInfiniteItemView_DataRequestEvent} from "./UiInfiniteItemViewConfig"
import {UiInfiniteItemView_ItemClickedEvent} from "./UiInfiniteItemViewConfig"
import {UiItemView_ItemClickedEvent} from "./UiItemViewConfig"
import {UiSplitPane_ResizedEvent} from "./UiSplitPaneConfig"
import {UiLiveStreamComponent_ResultOfRequestInputDeviceAccessEvent} from "./UiLiveStreamComponentConfig"
import {UiLiveStreamComponent_ResultOfRequestInputDeviceInfoEvent} from "./UiLiveStreamComponentConfig"
import {UiLiveStreamComponent_ResultOfGetFlashPlayerVersionEvent} from "./UiLiveStreamComponentConfig"
import {UiRtmpLiveStreamPlayer_ResultOfGetFlashPlayerVersionEvent} from "./UiRtmpLiveStreamPlayerConfig"
import {UiMap_ZoomLevelChangeEvent} from "./UiMapConfig"
import {UiMediaTrackGraph_HandleTimeSelectionEvent} from "./UiMediaTrackGraphConfig"
import {UiVideoPlayer_ErrorLoadingEvent} from "./UiVideoPlayerConfig"
import {UiVideoPlayer_PlayerProgressEvent} from "./UiVideoPlayerConfig"
import {UiNavigationBar_ButtonClickedEvent} from "./UiNavigationBarConfig"
import {UiNetworkGraph_HandleNodeClickEvent} from "./UiNetworkGraphConfig"
import {UiPanel_ToolButtonClickedEvent} from "./UiPanelConfig"
import {UiPanel_ToolButtonDropDownItemClickedEvent} from "./UiPanelConfig"

import {UiTable_CellEditingStartedEvent} from "./UiTableConfig"
import {UiTable_CellEditingStoppedEvent} from "./UiTableConfig"
import {UiTable_RowSelectedEvent} from "./UiTableConfig"
import {UiTable_MultipleRowsSelectedEvent} from "./UiTableConfig"
import {UiTable_SortingChangedEvent} from "./UiTableConfig"
import {UiTable_TableDataRequestEvent} from "./UiTableConfig"
import {UiTable_RequestNestedDataEvent} from "./UiTableConfig"
import {UiTable_FieldOrderChangeEvent} from "./UiTableConfig"
import {UiTable_ColumnSizeChangeEvent} from "./UiTableConfig"
import {UiTable_HeaderFieldValueChangedEvent} from "./UiTableConfig"
import {UiTable_HeaderFieldEventEvent} from "./UiTableConfig"
import {UiTable_FooterFieldValueChangedEvent} from "./UiTableConfig"
import {UiTable_FooterFieldEventEvent} from "./UiTableConfig"
import {UiTabPanel_TabSelectedEvent} from "./UiTabPanelConfig"
import {UiTabPanel_TabNeedsRefreshEvent} from "./UiTabPanelConfig"
import {UiTabPanel_TabClosedEvent} from "./UiTabPanelConfig"
import {UiTabPanel_ToolButtonClickedEvent} from "./UiTabPanelConfig"
import {UiTabPanel_ToolButtonDropDownItemClickedEvent} from "./UiTabPanelConfig"
import {UiTimeGraph_DataNeededEvent} from "./UiTimeGraphConfig"
import {UiTimeGraph_ZoomedEvent} from "./UiTimeGraphConfig"
import {UiTimeGraph_IntervalSelectedEvent} from "./UiTimeGraphConfig"
import {AbstractUiToolContainer_ToolbarButtonClickEvent} from "./AbstractUiToolContainerConfig"
import {AbstractUiToolContainer_ToolbarDropDownItemClickEvent} from "./AbstractUiToolContainerConfig"


import {UiTree_NodeSelectedEvent} from "./UiTreeConfig"
import {UiTree_RequestTreeDataEvent} from "./UiTreeConfig"
import {UiWorkSpaceLayout_LayoutChangedEvent} from "./UiWorkSpaceLayoutConfig"
import {UiWorkSpaceLayout_ViewDraggedToNewWindowEvent} from "./UiWorkSpaceLayoutConfig"
import {UiWorkSpaceLayout_ViewNeedsRefreshEvent} from "./UiWorkSpaceLayoutConfig"
import {UiWorkSpaceLayout_ChildWindowCreationFailedEvent} from "./UiWorkSpaceLayoutConfig"
import {UiWorkSpaceLayout_ChildWindowClosedEvent} from "./UiWorkSpaceLayoutConfig"
import {UiWorkSpaceLayout_ViewTabSelectedEvent} from "./UiWorkSpaceLayoutConfig"
import {UiWorkSpaceLayout_ViewTabClosedEvent} from "./UiWorkSpaceLayoutConfig"
import {UiWorkSpaceLayout_ViewsMinimizedEvent} from "./UiWorkSpaceLayoutConfig"
import {UiWorkSpaceLayout_ViewsRestoredEvent} from "./UiWorkSpaceLayoutConfig"
import {UiWorkSpaceLayout_ViewsMaximizedEvent} from "./UiWorkSpaceLayoutConfig"
import {UiSingleRecordFieldContainer_FieldValueChangedEvent} from "./UiSingleRecordFieldContainerConfig"
import {UiSingleRecordFieldContainer_FieldEventEvent} from "./UiSingleRecordFieldContainerConfig"
import {UiMultiRecordFieldContainer_FieldValueChangedEvent} from "./UiMultiRecordFieldContainerConfig"
import {UiMultiRecordFieldContainer_FieldEventEvent} from "./UiMultiRecordFieldContainerConfig"
import {UiCalendarViewMode} from "./UiCalendarViewMode";
import {UiAudioInputDeviceInfoConfig} from "./UiAudioInputDeviceInfoConfig";
import {UiVideoInputDeviceInfoConfig} from "./UiVideoInputDeviceInfoConfig";
import {UiSortDirection} from "./UiSortDirection";
import {UiLongIntervalConfig} from "./UiLongIntervalConfig";
import {UiDropDownButtonClickInfoConfig} from "./UiDropDownButtonClickInfoConfig";
import {UiWorkSpaceLayoutItemConfig} from "./UiWorkSpaceLayoutItemConfig";

export class EventFactory {

	    public static createUiDummyComponent_ClickedEvent(componentId:string, clickCount: number): UiDummyComponent_ClickedEvent {
	        return {
	            _type: "UiDummyComponent.clicked",
	            componentId: componentId,
	            clickCount: clickCount
	        };
	    }
	    public static createUiCalendar_EventClickedEvent(componentId:string, eventId: any, isDoubleClick: boolean): UiCalendar_EventClickedEvent {
	        return {
	            _type: "UiCalendar.eventClicked",
	            componentId: componentId,
	            eventId: eventId,
	            isDoubleClick: isDoubleClick
	        };
	    }public static createUiCalendar_EventMovedEvent(componentId:string, eventId: any, newStart: number, newEnd: number): UiCalendar_EventMovedEvent {
	        return {
	            _type: "UiCalendar.eventMoved",
	            componentId: componentId,
	            eventId: eventId,
	            newStart: newStart,
	            newEnd: newEnd
	        };
	    }public static createUiCalendar_DayClickedEvent(componentId:string, date: number, isDoubleClick: boolean): UiCalendar_DayClickedEvent {
	        return {
	            _type: "UiCalendar.dayClicked",
	            componentId: componentId,
	            date: date,
	            isDoubleClick: isDoubleClick
	        };
	    }public static createUiCalendar_ViewChangedEvent(componentId:string, viewMode: UiCalendarViewMode, mainIntervalStart: number, mainIntervalEnd: number, displayedIntervalStart: number, displayedIntervalEnd: number): UiCalendar_ViewChangedEvent {
	        return {
	            _type: "UiCalendar.viewChanged",
	            componentId: componentId,
	            viewMode: viewMode,
	            mainIntervalStart: mainIntervalStart,
	            mainIntervalEnd: mainIntervalEnd,
	            displayedIntervalStart: displayedIntervalStart,
	            displayedIntervalEnd: displayedIntervalEnd
	        };
	    }public static createUiCalendar_DataNeededEvent(componentId:string, requestIntervalStart: number, requestIntervalEnd: number): UiCalendar_DataNeededEvent {
	        return {
	            _type: "UiCalendar.dataNeeded",
	            componentId: componentId,
	            requestIntervalStart: requestIntervalStart,
	            requestIntervalEnd: requestIntervalEnd
	        };
	    }
	    public static createUiContextMenu_ContextMenuSelectionEvent(componentId:string, entryId: string): UiContextMenu_ContextMenuSelectionEvent {
	        return {
	            _type: "UiContextMenu.contextMenuSelection",
	            componentId: componentId,
	            entryId: entryId
	        };
	    }
	    public static createUiGridForm_SubmittedEvent(componentId:string, data: any): UiGridForm_SubmittedEvent {
	        return {
	            _type: "UiGridForm.submitted",
	            componentId: componentId,
	            data: data
	        };
	    }public static createUiGridForm_SectionCollapsedStateChangedEvent(componentId:string, sectionId: string, collapsed: boolean): UiGridForm_SectionCollapsedStateChangedEvent {
	        return {
	            _type: "UiGridForm.sectionCollapsedStateChanged",
	            componentId: componentId,
	            sectionId: sectionId,
	            collapsed: collapsed
	        };
	    }
	    public static createUiImageDisplay_ImagesRequestEvent(componentId:string, startIndex: number, length: number): UiImageDisplay_ImagesRequestEvent {
	        return {
	            _type: "UiImageDisplay.imagesRequest",
	            componentId: componentId,
	            startIndex: startIndex,
	            length: length
	        };
	    }public static createUiImageDisplay_ImageDisplayedEvent(componentId:string, imageId: string): UiImageDisplay_ImageDisplayedEvent {
	        return {
	            _type: "UiImageDisplay.imageDisplayed",
	            componentId: componentId,
	            imageId: imageId
	        };
	    }
	    public static createUiImageCropper_CropFrameChangedEvent(componentId:string, left: number, top: number, width: number, height: number): UiImageCropper_CropFrameChangedEvent {
	        return {
	            _type: "UiImageCropper.cropFrameChanged",
	            componentId: componentId,
	            left: left,
	            top: top,
	            width: width,
	            height: height
	        };
	    }
	    public static createUiInfiniteItemView_DataRequestEvent(componentId:string, startIndex: number, length: number): UiInfiniteItemView_DataRequestEvent {
	        return {
	            _type: "UiInfiniteItemView.dataRequest",
	            componentId: componentId,
	            startIndex: startIndex,
	            length: length
	        };
	    }public static createUiInfiniteItemView_ItemClickedEvent(componentId:string, recordId: any, isRightMouseButton: boolean, isDoubleClick: boolean): UiInfiniteItemView_ItemClickedEvent {
	        return {
	            _type: "UiInfiniteItemView.itemClicked",
	            componentId: componentId,
	            recordId: recordId,
	            isRightMouseButton: isRightMouseButton,
	            isDoubleClick: isDoubleClick
	        };
	    }
	    public static createUiItemView_ItemClickedEvent(componentId:string, groupId: string, itemId: any): UiItemView_ItemClickedEvent {
	        return {
	            _type: "UiItemView.itemClicked",
	            componentId: componentId,
	            groupId: groupId,
	            itemId: itemId
	        };
	    }
	    public static createUiSplitPane_ResizedEvent(componentId:string, referenceChildSize: number): UiSplitPane_ResizedEvent {
	        return {
	            _type: "UiSplitPane.resized",
	            componentId: componentId,
	            referenceChildSize: referenceChildSize
	        };
	    }
	    public static createUiLiveStreamComponent_ResultOfRequestInputDeviceAccessEvent(componentId:string, microphoneAccessGranted: boolean, cameraAccessGranted: boolean): UiLiveStreamComponent_ResultOfRequestInputDeviceAccessEvent {
	        return {
	            _type: "UiLiveStreamComponent.resultOfRequestInputDeviceAccess",
	            componentId: componentId,
	            microphoneAccessGranted: microphoneAccessGranted,
	            cameraAccessGranted: cameraAccessGranted
	        };
	    }public static createUiLiveStreamComponent_ResultOfRequestInputDeviceInfoEvent(componentId:string, audioInputDeviceInfo: UiAudioInputDeviceInfoConfig, videoInputDeviceInfo: UiVideoInputDeviceInfoConfig): UiLiveStreamComponent_ResultOfRequestInputDeviceInfoEvent {
	        return {
	            _type: "UiLiveStreamComponent.resultOfRequestInputDeviceInfo",
	            componentId: componentId,
	            audioInputDeviceInfo: audioInputDeviceInfo,
	            videoInputDeviceInfo: videoInputDeviceInfo
	        };
	    }public static createUiLiveStreamComponent_ResultOfGetFlashPlayerVersionEvent(componentId:string, versionAvailableOnClient: string, versionNeeded: string, sufficiant: boolean): UiLiveStreamComponent_ResultOfGetFlashPlayerVersionEvent {
	        return {
	            _type: "UiLiveStreamComponent.resultOfGetFlashPlayerVersion",
	            componentId: componentId,
	            versionAvailableOnClient: versionAvailableOnClient,
	            versionNeeded: versionNeeded,
	            sufficiant: sufficiant
	        };
	    }
	    public static createUiRtmpLiveStreamPlayer_ResultOfGetFlashPlayerVersionEvent(componentId:string, versionAvailableOnClient: string, versionNeeded: string, sufficiant: boolean): UiRtmpLiveStreamPlayer_ResultOfGetFlashPlayerVersionEvent {
	        return {
	            _type: "UiRtmpLiveStreamPlayer.resultOfGetFlashPlayerVersion",
	            componentId: componentId,
	            versionAvailableOnClient: versionAvailableOnClient,
	            versionNeeded: versionNeeded,
	            sufficiant: sufficiant
	        };
	    }
	    public static createUiMap_ZoomLevelChangeEvent(componentId:string, zoomLevel: number): UiMap_ZoomLevelChangeEvent {
	        return {
	            _type: "UiMap.zoomLevelChange",
	            componentId: componentId,
	            zoomLevel: zoomLevel
	        };
	    }
	    public static createUiMediaTrackGraph_HandleTimeSelectionEvent(componentId:string, start: number, end: number): UiMediaTrackGraph_HandleTimeSelectionEvent {
	        return {
	            _type: "UiMediaTrackGraph.handleTimeSelection",
	            componentId: componentId,
	            start: start,
	            end: end
	        };
	    }
	    public static createUiVideoPlayer_ErrorLoadingEvent(componentId:string): UiVideoPlayer_ErrorLoadingEvent {
	        return {
	            _type: "UiVideoPlayer.errorLoading",
	            componentId: componentId,
	        };
	    }public static createUiVideoPlayer_PlayerProgressEvent(componentId:string, positionInSeconds: number): UiVideoPlayer_PlayerProgressEvent {
	        return {
	            _type: "UiVideoPlayer.playerProgress",
	            componentId: componentId,
	            positionInSeconds: positionInSeconds
	        };
	    }
	    public static createUiNavigationBar_ButtonClickedEvent(componentId:string, buttonId: string, visibleFanOutComponentId: string): UiNavigationBar_ButtonClickedEvent {
	        return {
	            _type: "UiNavigationBar.buttonClicked",
	            componentId: componentId,
	            buttonId: buttonId,
	            visibleFanOutComponentId: visibleFanOutComponentId
	        };
	    }
	    public static createUiNetworkGraph_HandleNodeClickEvent(componentId:string, nodeId: string): UiNetworkGraph_HandleNodeClickEvent {
	        return {
	            _type: "UiNetworkGraph.handleNodeClick",
	            componentId: componentId,
	            nodeId: nodeId
	        };
	    }
	    public static createUiPanel_ToolButtonClickedEvent(componentId:string, toolButtonId: string): UiPanel_ToolButtonClickedEvent {
	        return {
	            _type: "UiPanel.toolButtonClicked",
	            componentId: componentId,
	            toolButtonId: toolButtonId
	        };
	    }public static createUiPanel_ToolButtonDropDownItemClickedEvent(componentId:string, toolButtonId: string, itemId: any): UiPanel_ToolButtonDropDownItemClickedEvent {
	        return {
	            _type: "UiPanel.toolButtonDropDownItemClicked",
	            componentId: componentId,
	            toolButtonId: toolButtonId,
	            itemId: itemId
	        };
	    }

	    public static createUiTable_CellEditingStartedEvent(componentId:string, recordId: any, fieldName: string, currentValue: any): UiTable_CellEditingStartedEvent {
	        return {
	            _type: "UiTable.cellEditingStarted",
	            componentId: componentId,
	            recordId: recordId,
	            fieldName: fieldName,
	            currentValue: currentValue
	        };
	    }public static createUiTable_CellEditingStoppedEvent(componentId:string, recordId: any, fieldName: string): UiTable_CellEditingStoppedEvent {
	        return {
	            _type: "UiTable.cellEditingStopped",
	            componentId: componentId,
	            recordId: recordId,
	            fieldName: fieldName
	        };
	    }public static createUiTable_RowSelectedEvent(componentId:string, recordId: any, isRightMouseButton: boolean, isDoubleClick: boolean): UiTable_RowSelectedEvent {
	        return {
	            _type: "UiTable.rowSelected",
	            componentId: componentId,
	            recordId: recordId,
	            isRightMouseButton: isRightMouseButton,
	            isDoubleClick: isDoubleClick
	        };
	    }public static createUiTable_MultipleRowsSelectedEvent(componentId:string, recordIds: any[]): UiTable_MultipleRowsSelectedEvent {
	        return {
	            _type: "UiTable.multipleRowsSelected",
	            componentId: componentId,
	            recordIds: recordIds
	        };
	    }public static createUiTable_SortingChangedEvent(componentId:string, sortField: string, sortDirection: UiSortDirection): UiTable_SortingChangedEvent {
	        return {
	            _type: "UiTable.sortingChanged",
	            componentId: componentId,
	            sortField: sortField,
	            sortDirection: sortDirection
	        };
	    }public static createUiTable_TableDataRequestEvent(componentId:string, startIndex: number, length: number, sortField: string, sortDirection: UiSortDirection): UiTable_TableDataRequestEvent {
	        return {
	            _type: "UiTable.tableDataRequest",
	            componentId: componentId,
	            startIndex: startIndex,
	            length: length,
	            sortField: sortField,
	            sortDirection: sortDirection
	        };
	    }public static createUiTable_RequestNestedDataEvent(componentId:string, recordId: any): UiTable_RequestNestedDataEvent {
	        return {
	            _type: "UiTable.requestNestedData",
	            componentId: componentId,
	            recordId: recordId
	        };
	    }public static createUiTable_FieldOrderChangeEvent(componentId:string, fieldName: string, position: number): UiTable_FieldOrderChangeEvent {
	        return {
	            _type: "UiTable.fieldOrderChange",
	            componentId: componentId,
	            fieldName: fieldName,
	            position: position
	        };
	    }public static createUiTable_ColumnSizeChangeEvent(componentId:string, fieldName: string, size: number): UiTable_ColumnSizeChangeEvent {
	        return {
	            _type: "UiTable.columnSizeChange",
	            componentId: componentId,
	            fieldName: fieldName,
	            size: size
	        };
	    }public static createUiTable_HeaderFieldValueChangedEvent(componentId:string, fieldName: string, value: any): UiTable_HeaderFieldValueChangedEvent {
	        return {
	            _type: "UiTable.headerFieldValueChanged",
	            componentId: componentId,
	            fieldName: fieldName,
	            value: value
	        };
	    }public static createUiTable_HeaderFieldEventEvent(componentId:string, fieldName: string, fieldEvent: UiSubEvent): UiTable_HeaderFieldEventEvent {
	        return {
	            _type: "UiTable.headerFieldEvent",
	            componentId: componentId,
	            fieldName: fieldName,
	            fieldEvent: fieldEvent
	        };
	    }public static createUiTable_FooterFieldValueChangedEvent(componentId:string, fieldName: string, value: any): UiTable_FooterFieldValueChangedEvent {
	        return {
	            _type: "UiTable.footerFieldValueChanged",
	            componentId: componentId,
	            fieldName: fieldName,
	            value: value
	        };
	    }public static createUiTable_FooterFieldEventEvent(componentId:string, fieldName: string, fieldEvent: UiSubEvent): UiTable_FooterFieldEventEvent {
	        return {
	            _type: "UiTable.footerFieldEvent",
	            componentId: componentId,
	            fieldName: fieldName,
	            fieldEvent: fieldEvent
	        };
	    }
	    public static createUiTabPanel_TabSelectedEvent(componentId:string, tabId: string): UiTabPanel_TabSelectedEvent {
	        return {
	            _type: "UiTabPanel.tabSelected",
	            componentId: componentId,
	            tabId: tabId
	        };
	    }public static createUiTabPanel_TabNeedsRefreshEvent(componentId:string, tabId: string): UiTabPanel_TabNeedsRefreshEvent {
	        return {
	            _type: "UiTabPanel.tabNeedsRefresh",
	            componentId: componentId,
	            tabId: tabId
	        };
	    }public static createUiTabPanel_TabClosedEvent(componentId:string, tabId: string): UiTabPanel_TabClosedEvent {
	        return {
	            _type: "UiTabPanel.tabClosed",
	            componentId: componentId,
	            tabId: tabId
	        };
	    }public static createUiTabPanel_ToolButtonClickedEvent(componentId:string, toolButtonId: string): UiTabPanel_ToolButtonClickedEvent {
	        return {
	            _type: "UiTabPanel.toolButtonClicked",
	            componentId: componentId,
	            toolButtonId: toolButtonId
	        };
	    }public static createUiTabPanel_ToolButtonDropDownItemClickedEvent(componentId:string, toolButtonId: string, itemId: any): UiTabPanel_ToolButtonDropDownItemClickedEvent {
	        return {
	            _type: "UiTabPanel.toolButtonDropDownItemClicked",
	            componentId: componentId,
	            toolButtonId: toolButtonId,
	            itemId: itemId
	        };
	    }
	    public static createUiTimeGraph_DataNeededEvent(componentId:string, zoomLevelIndex: number, neededIntervalX: UiLongIntervalConfig): UiTimeGraph_DataNeededEvent {
	        return {
	            _type: "UiTimeGraph.dataNeeded",
	            componentId: componentId,
	            zoomLevelIndex: zoomLevelIndex,
	            neededIntervalX: neededIntervalX
	        };
	    }public static createUiTimeGraph_ZoomedEvent(componentId:string, intervalX: UiLongIntervalConfig, zoomLevelIndex: number): UiTimeGraph_ZoomedEvent {
	        return {
	            _type: "UiTimeGraph.zoomed",
	            componentId: componentId,
	            intervalX: intervalX,
	            zoomLevelIndex: zoomLevelIndex
	        };
	    }public static createUiTimeGraph_IntervalSelectedEvent(componentId:string, intervalX: UiLongIntervalConfig): UiTimeGraph_IntervalSelectedEvent {
	        return {
	            _type: "UiTimeGraph.intervalSelected",
	            componentId: componentId,
	            intervalX: intervalX
	        };
	    }
	    public static createAbstractUiToolContainer_ToolbarButtonClickEvent(componentId:string, groupId: string, buttonId: string, dropDownClickInfo: UiDropDownButtonClickInfoConfig): AbstractUiToolContainer_ToolbarButtonClickEvent {
	        return {
	            _type: "AbstractUiToolContainer.toolbarButtonClick",
	            componentId: componentId,
	            groupId: groupId,
	            buttonId: buttonId,
	            dropDownClickInfo: dropDownClickInfo
	        };
	    }public static createAbstractUiToolContainer_ToolbarDropDownItemClickEvent(componentId:string, groupId: string, buttonId: string, dropDownGroupId: string, dropDownItemId: any): AbstractUiToolContainer_ToolbarDropDownItemClickEvent {
	        return {
	            _type: "AbstractUiToolContainer.toolbarDropDownItemClick",
	            componentId: componentId,
	            groupId: groupId,
	            buttonId: buttonId,
	            dropDownGroupId: dropDownGroupId,
	            dropDownItemId: dropDownItemId
	        };
	    }


	    public static createUiTree_NodeSelectedEvent(componentId:string, node: any): UiTree_NodeSelectedEvent {
	        return {
	            _type: "UiTree.nodeSelected",
	            componentId: componentId,
	            node: node
	        };
	    }public static createUiTree_RequestTreeDataEvent(componentId:string, parentNodeId: any): UiTree_RequestTreeDataEvent {
	        return {
	            _type: "UiTree.requestTreeData",
	            componentId: componentId,
	            parentNodeId: parentNodeId
	        };
	    }
	    public static createUiWorkSpaceLayout_LayoutChangedEvent(componentId:string, layoutsByWindowId: {[name: string]: UiWorkSpaceLayoutItemConfig}): UiWorkSpaceLayout_LayoutChangedEvent {
	        return {
	            _type: "UiWorkSpaceLayout.layoutChanged",
	            componentId: componentId,
	            layoutsByWindowId: layoutsByWindowId
	        };
	    }public static createUiWorkSpaceLayout_ViewDraggedToNewWindowEvent(componentId:string, windowId: string, viewName: string): UiWorkSpaceLayout_ViewDraggedToNewWindowEvent {
	        return {
	            _type: "UiWorkSpaceLayout.viewDraggedToNewWindow",
	            componentId: componentId,
	            windowId: windowId,
	            viewName: viewName
	        };
	    }public static createUiWorkSpaceLayout_ViewNeedsRefreshEvent(componentId:string, viewName: string): UiWorkSpaceLayout_ViewNeedsRefreshEvent {
	        return {
	            _type: "UiWorkSpaceLayout.viewNeedsRefresh",
	            componentId: componentId,
	            viewName: viewName
	        };
	    }public static createUiWorkSpaceLayout_ChildWindowCreationFailedEvent(componentId:string, viewName: string): UiWorkSpaceLayout_ChildWindowCreationFailedEvent {
	        return {
	            _type: "UiWorkSpaceLayout.childWindowCreationFailed",
	            componentId: componentId,
	            viewName: viewName
	        };
	    }public static createUiWorkSpaceLayout_ChildWindowClosedEvent(componentId:string, windowId: string, viewsInWindow: string[]): UiWorkSpaceLayout_ChildWindowClosedEvent {
	        return {
	            _type: "UiWorkSpaceLayout.childWindowClosed",
	            componentId: componentId,
	            windowId: windowId,
	            viewsInWindow: viewsInWindow
	        };
	    }public static createUiWorkSpaceLayout_ViewTabSelectedEvent(componentId:string, viewName: string, siblingViewNames: string[]): UiWorkSpaceLayout_ViewTabSelectedEvent {
	        return {
	            _type: "UiWorkSpaceLayout.viewTabSelected",
	            componentId: componentId,
	            viewName: viewName,
	            siblingViewNames: siblingViewNames
	        };
	    }public static createUiWorkSpaceLayout_ViewTabClosedEvent(componentId:string, viewName: string): UiWorkSpaceLayout_ViewTabClosedEvent {
	        return {
	            _type: "UiWorkSpaceLayout.viewTabClosed",
	            componentId: componentId,
	            viewName: viewName
	        };
	    }public static createUiWorkSpaceLayout_ViewsMinimizedEvent(componentId:string, viewNames: string[]): UiWorkSpaceLayout_ViewsMinimizedEvent {
	        return {
	            _type: "UiWorkSpaceLayout.viewsMinimized",
	            componentId: componentId,
	            viewNames: viewNames
	        };
	    }public static createUiWorkSpaceLayout_ViewsRestoredEvent(componentId:string, viewNames: string[]): UiWorkSpaceLayout_ViewsRestoredEvent {
	        return {
	            _type: "UiWorkSpaceLayout.viewsRestored",
	            componentId: componentId,
	            viewNames: viewNames
	        };
	    }public static createUiWorkSpaceLayout_ViewsMaximizedEvent(componentId:string, viewNames: string[]): UiWorkSpaceLayout_ViewsMaximizedEvent {
	        return {
	            _type: "UiWorkSpaceLayout.viewsMaximized",
	            componentId: componentId,
	            viewNames: viewNames
	        };
	    }
	    public static createUiSingleRecordFieldContainer_FieldValueChangedEvent(componentId:string, fieldName: string, value: any): UiSingleRecordFieldContainer_FieldValueChangedEvent {
	        return {
	            _type: "UiSingleRecordFieldContainer.fieldValueChanged",
	            componentId: componentId,
	            fieldName: fieldName,
	            value: value
	        };
	    }public static createUiSingleRecordFieldContainer_FieldEventEvent(componentId:string, fieldName: string, fieldEvent: UiSubEvent): UiSingleRecordFieldContainer_FieldEventEvent {
	        return {
	            _type: "UiSingleRecordFieldContainer.fieldEvent",
	            componentId: componentId,
	            fieldName: fieldName,
	            fieldEvent: fieldEvent
	        };
	    }
	    public static createUiMultiRecordFieldContainer_FieldValueChangedEvent(componentId:string, recordId: any, fieldName: string, value: any): UiMultiRecordFieldContainer_FieldValueChangedEvent {
	        return {
	            _type: "UiMultiRecordFieldContainer.fieldValueChanged",
	            componentId: componentId,
	            recordId: recordId,
	            fieldName: fieldName,
	            value: value
	        };
	    }public static createUiMultiRecordFieldContainer_FieldEventEvent(componentId:string, recordId: any, fieldName: string, fieldEvent: UiSubEvent): UiMultiRecordFieldContainer_FieldEventEvent {
	        return {
	            _type: "UiMultiRecordFieldContainer.fieldEvent",
	            componentId: componentId,
	            recordId: recordId,
	            fieldName: fieldName,
	            fieldEvent: fieldEvent
	        };
	    }

}